import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from "@angular/core";
import { LobbyFilters } from "../../../shared/enums/poker-types";

export interface LobbyHomeGridItem {
  id: string;
  title: string;
  imageUrl: string;
}

export interface LobbyHomeGameType {
  realValue: number;
  displayValue: string;
}

@Component({
  selector: "app-lobby-home-grid",
  templateUrl: "./lobby-home-grid.component.html",
  styleUrls: ["./lobby-home-grid.component.scss"],
})
export class LobbyHomeGridComponent implements OnChanges {
  @Input() skinCode = "";
  @Input() assetBaseUrl = "";
  @Input() gameTypes: LobbyHomeGameType[] = [];

  @Output() cashGames = new EventEmitter<void>();
  @Output() holdem = new EventEmitter<void>();
  @Output() omaha = new EventEmitter<void>();
  @Output() sitAndGo = new EventEmitter<void>();
  @Output() tournaments = new EventEmitter<void>();
  @Output() spinAndGo = new EventEmitter<void>();

  items: LobbyHomeGridItem[] = [];

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.skinCode || changes.assetBaseUrl || changes.gameTypes) {
      this.buildItems();
    }
  }

  trackById(_index: number, item: LobbyHomeGridItem): string {
    return item.id;
  }

  onItemClick(id: string): void {
    switch (id) {
      case "cashgames":
        this.cashGames.emit();
        break;
      case "holdem":
        this.holdem.emit();
        break;
      case "omaha":
        this.omaha.emit();
        break;
      case "sitngo":
        this.sitAndGo.emit();
        break;
      case "tournaments":
        this.tournaments.emit();
        break;
      case "spinngo":
        this.spinAndGo.emit();
        break;
    }
  }

  private buildItems(): void {
    if (!this.assetBaseUrl || !this.skinCode) {
      this.items = [];
      return;
    }

    const thumbBase = `${this.assetBaseUrl}/assets/${this.skinCode}/lobby-thumbnails`;
    const items: LobbyHomeGridItem[] = [
      {
        id: "holdem",
        title: "Hold'Em",
        imageUrl: `${thumbBase}/lobby_thumbnail_holdem.png`,
      },
      {
        id: "omaha",
        title: "Omaha",
        imageUrl: `${thumbBase}/lobby_thumbnail_omaha.png`,
      },
    ];

    for (const gameType of this.gameTypes || []) {
      const mapped = this.mapGameType(gameType, thumbBase);
      if (mapped) {
        items.push(mapped);
      }
    }

    this.items = items;
  }

  private mapGameType(
    gameType: LobbyHomeGameType,
    thumbBase: string,
  ): LobbyHomeGridItem | null {
    switch (gameType.realValue) {
      case LobbyFilters.TypeRing:
        return null;
      case LobbyFilters.TypeSitnGo:
        return {
          id: "sitngo",
          title: "Sit & Go",
          imageUrl: `${thumbBase}/lobby_thumbnail_sitngo.png`,
        };
      case LobbyFilters.TypeTournament:
        return {
          id: "tournaments",
          title: "Tournaments",
          imageUrl: `${thumbBase}/lobby_thumbnail_tournaments.png`,
        };
      case LobbyFilters.TypeSpinAndGo:
        return {
          id: "spinngo",
          title: "Spin & Go",
          imageUrl: `${thumbBase}/lobby_thumbnail_spinngo.png`,
        };
      default:
        return null;
    }
  }
}
